import { useMemo } from 'react';
import { useData } from '../store/data';
import { useFilters } from '../store/filters';
import { applyFilters } from '../lib/filter-rows';
import {
  buildTrendIndex, computeRolling30, emptyMonth, trendFieldsAvailable,
  type MonthlyTrend, type Rolling30, type TrendIndex,
} from '../lib/trend';

export type TrendData = {
  index: TrendIndex;
  available: { created: boolean; resolved: boolean };
  totals: MonthlyTrend;
  rolling30: Rolling30;
};

// Trend-Daten — Created/Resolved pro Monat — werden auf die GEFILTERTEN Rows
// gerechnet, damit Team- und sonstige Filter wirken. Wird auf rows + Filter
// memoisiert.
export function useTrend(): TrendData {
  const rows     = useData(s => s.rows);
  const search   = useFilters(s => s.search);
  const team     = useFilters(s => s.team);
  const assignee = useFilters(s => s.assignee);
  const status   = useFilters(s => s.status);
  const priority = useFilters(s => s.priority);

  return useMemo(() => {
    const filtered = applyFilters(rows, {
      search, team, assignee, status, priority, spToPtFactor: 1,
    });
    const index = buildTrendIndex(filtered);
    const available = trendFieldsAvailable(filtered);

    const totals = emptyMonth();
    for (const m of index.values()) {
      totals.openedStories       += m.openedStories;
      totals.openedBugs          += m.openedBugs;
      totals.openedCustomerBugs  += m.openedCustomerBugs;
      totals.openedInternalBugs  += m.openedInternalBugs;
      totals.closedStories       += m.closedStories;
      totals.closedBugs          += m.closedBugs;
      totals.closedCustomerBugs  += m.closedCustomerBugs;
      totals.closedInternalBugs  += m.closedInternalBugs;
    }
    const rolling30 = computeRolling30(filtered);
    return { index, available, totals, rolling30 };
  }, [rows, search, team, assignee, status, priority]);
}
